/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Witty_Home_Frog_CoaxInputs */

const fr_witty_home_frog_coax = /** @type {(inputs: Witty_Home_Frog_CoaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur lors de la suppression`)
};

/**

* @param {Witty_Home_Frog_CoaxInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const witty_home_frog_coax = /** @type {((inputs?: Witty_Home_Frog_CoaxInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Witty_Home_Frog_CoaxInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_witty_home_frog_coax(inputs)
});